import React from 'react'
import { Updater, fromJSX, Widget } from 'widgets-for-react'
import { Cookie, setCookie } from '../../utils/cookies'
import { DataLayer } from '../../utils/datalayer'
import { ComponentDidMount } from '../../utils/lifecycleMethods'
import { CookiebarLayout, CookiePlaceholderLayout } from './cookiebarLayout'
import { CookiebarState, cookiebarStateUpdaters } from './cookiebarState'
import { acceptAllCookies, acceptSelectedCookies, denyAllCookies } from '../../utils/datalayer.mapping'

export const cookiebarWidget = (
  state: CookiebarState,
  cookieToShow: Cookie | 'all' = 'all'
): Widget<Updater<CookiebarState>> =>
  fromJSX((setState) => {
    if (!state.cookieBarVisible) return <></>

    if (cookieToShow !== 'all') {
      return (
        <CookiePlaceholderLayout
          onAccept={() => {
            setCookie(cookieToShow, 'yes', 1000)
            setState(cookiebarStateUpdaters.singleCookieUpdater(cookieToShow, 'yes'))
          }}
        />
      )
    }

    return (
      <ComponentDidMount onMount={DataLayer.showCookies}>
        <CookiebarLayout
          onAcceptAll={() => acceptAllCookies() }
          onDeclineAll={() => denyAllCookies() }
          onApplySettings={() => acceptSelectedCookies(state.cookies) }
          onSetSingle={(name, value) => setState(cookiebarStateUpdaters.singleCookieUpdater(name, value))}
          showOptions={state.expandOptions}
          toggleOptions={() => setState(cookiebarStateUpdaters.expandOptionsUpdater)}
          cookieValues={state.cookies}
          // svgIcon={{ width: '24px', height: '24px' }}
          expandSVGIcon={{ width: '6px', height: '10px' }}
        />
      </ComponentDidMount>
    )
  })
